import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const initialState = {
  expanded: true,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.expanded = !state.expanded;
      // Guardamos el estado del sidebar en cookies para persistencia
      Cookies.set('sidebar-expanded', state.expanded, { expires: 7 });
    },
    initializeSidebar: (state) => {
      // Recuperamos el estado del sidebar desde la cookie
      const savedState = Cookies.get('sidebar-expanded');
      if (savedState) {
        state.expanded = JSON.parse(savedState);  // Convertimos el valor guardado a booleano
      }
    },
  },
});

export const { toggleSidebar, initializeSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;
